import profileImage from "../assets/profile-image.png";

function Intro() {
  return (
    <section className="section intro">
      <div className="container-fluid">
        <div className="row align-items-center">

          {/* LEFT: TEXT */}
          <div className="col-md-7 intro-text">
            <h1>
              Building intelligent systems across AI and engineering.
            </h1>

            <p className="mt-3">
              I work at the intersection of machine learning, software systems,
              and computer engineering, focusing on building reliable,
              research-driven solutions that scale from theory to practice.
            </p>

            <div className="intro-tags mt-4">
              <span>AI</span> • <span>Systems</span> •{" "}
              <span>Computer Vision</span> • <span>Verification</span>
            </div>
          </div>

          {/* RIGHT: IMAGE */}
          <div className="col-md-5 text-md-center mt-5 mt-md-0">
            <img
              src={profileImage}
              alt="Profile"
              className="img-fluid intro-image"
            />
          </div>

        </div>
      </div>
    </section>
  );
}

export default Intro;
